import React from 'react'
import PropTypes from 'prop-types'
import SearchForm from '../../../baseApp/shared/components/searchForm/SearchForm';
import { scheduleEventsSearchFields } from '../utils/searchFields';
import DataTable from '../../../baseApp/shared/components/table/DataTable';
import { I18n } from 'react-redux-i18n';

const MeetingRoomsScheduleEvents = ({
    searchFieldsValues,
    universalSearchField,
    handleSearchFieldChange,
    handleUniversalSearchFieldChange,
    handleSearchSubmit,
    handleSearchClear,
    handleSortChanged,
    data = [],
    pages = 0,
    currentPage = 0,
    pageSize,
    totalElements,
    sort: {
        property = "",
        direction = "ASC"
    },
    onPageChange,
    onPageSizeChange,
}) => {
    const columns = [{
        Header: I18n.t("meetingRooms.scheduleEvents.creationTimestamp"),
        accessor: "creationTimestamp",
        sortable: true
    }, {
        Header: I18n.t("meetingRooms.scheduleEvents.eventType"),
        id: "eventType",
        accessor: entry => I18n.t('meetingRooms.scheduleEvents.types.' + entry.eventType),
        sortable: true
    }, {
        Header: I18n.t("meetingRooms.scheduleEvents.description"),
        id: 'scheduleEntryInfo.title',
        accessor: entry => entry.scheduleEntryTitle,
        sortable: true
    }, {
        Header: I18n.t("meetingRooms.scheduleEvents.owner"),
        accessor: "scheduleEntryOwner",
        sortable: false
    }, {
        Header: I18n.t("meetingRooms.scheduleEvents.eventOrigin"),
        accessor: entry => I18n.t('meetingRooms.scheduleEvents.origins.' + entry.eventOrigin),
        id: "eventOrigin",
        sortable: true
    }, {
        Header: I18n.t("meetingRooms.scheduleEvents.entryStartEnd"),
        accessor: "entryStartEnd",
        sortable: false
    }];

    return <div className="page_background">
        <SearchForm
            content={scheduleEventsSearchFields(searchFieldsValues)}
            universalSearchField={universalSearchField}
            handleFieldChange={handleSearchFieldChange}
            handleUniversalSearchFieldChange={handleUniversalSearchFieldChange}
            handleClear={handleSearchClear}
            handleSubmit={handleSearchSubmit}
            hideAddButton
        />
        <DataTable
            //State dependent
            data={data}

            //Pagination
            pages={pages}
            selectedPage={currentPage}
            pageSize={pageSize}
            sortDirection={direction}
            sortProperty={property}
            totalElements={totalElements}
            pageSizeOptions={[10, 20, 50]}
            onPageChange={onPageChange}
            onPageSizeChange={onPageSizeChange}
            onSortChanged={handleSortChanged}

            //State independent / Configuration
            columns={columns}
            hasStatusBar={false}
            rowIsClickable={false}
        />
    </div>
};

MeetingRoomsScheduleEvents.propTypes = {
    searchFieldsValues: PropTypes.object.isRequired,
    handleSearchFieldChange: PropTypes.func,
    handleSearchSubmit: PropTypes.func,
    handleSearchClear: PropTypes.func,
    data: PropTypes.array,
    pages: PropTypes.number,
};

export default MeetingRoomsScheduleEvents;